import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

/**
 * Compact ERP search field (no attached search button).
 */
const ListSearch = ({
  value,
  onChange,
  placeholder,
  className = "",
  style,
  width = 280,
  allowClear = true,
}) => {
  const { t } = useTranslation();

  return (
    <Input
      allowClear={allowClear}
      value={value}
      prefix={<SearchOutlined className="list-search-icon" />}
      placeholder={placeholder || t("searchPlaceholder")}
      className={`list-search ${className}`.trim()}
      style={{ width, maxWidth: "100%", ...style }}
      onChange={(e) => onChange?.(e.target.value)}
      onPressEnter={(e) => onChange?.(e.target.value)}
    />
  );
};

export default ListSearch;
